<div class="minhas-contas-card">
  <div class="card-header-row">
    <h3 class="section-title">
      <i class="pi pi-building"></i>
      {{ texts.minhas_contas }}
    </h3>
    <button pButton type="button"
            [label]="texts.ver_todos"
            class="p-button-text p-button-sm"
            icon="pi pi-external-link"
            (click)="irParaContas()">
    </button>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="loading-container">
    <p-progressSpinner [style]="{ width: '40px', height: '40px' }"></p-progressSpinner>
  </div>

  <!-- Tabela -->
  <div *ngIf="!loading && contas.length > 0">
    <p-table [value]="contas | slice:0:10" [paginator]="false" styleClass="p-datatable-sm">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 50px">#</th>
          <th>{{ texts.conta }}</th>
          <th class="text-right">{{ texts.saldo }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-conta let-rowIndex="rowIndex">
        <tr [class.linha-par]="rowIndex % 2 === 0"
            class="linha-clicavel"
            (click)="irParaTransacoes(conta)">
          <td>{{ rowIndex + 1 }}</td>
          <td>{{ conta.tituloDaConta }}</td>
          <td class="text-right" [class.saldo-positivo]="conta.saldo >= 0" [class.saldo-negativo]="conta.saldo < 0">
            {{ formatarValorMonetario(conta.saldo, conta) }}
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div *ngIf="contasExcedentes > 0" class="mais-contas-info">
      <span class="mais-contas-texto">{{ textoMaisContas }}</span>
    </div>
  </div>

  <!-- Empty state -->
  <div *ngIf="!loading && contas.length === 0" class="empty-state">
    <i class="pi pi-inbox"></i>
  </div>
</div>

<!-- Dialog de Minhas Contas -->
<p-dialog [(visible)]="showDialogContas"
          [modal]="true"
          [style]="{ width: '600px' }"
          [breakpoints]="{ '650px': '95vw' }"
          [draggable]="false"
          [resizable]="false"
          [showHeader]="false"
          styleClass="dialog-contas-cards">

  <!-- Wave Header -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-wallet" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.minhas_contas }}</h2>
        <p *ngIf="contasDialog.length > 0">
          {{ contasDialog.length }} {{ texts.conta }}{{ contasDialog.length > 1 ? 's' : '' }}
        </p>
      </div>
    </div>
    <div class="dialog-wave-header-actions">
      <button pButton type="button"
              icon="pi pi-plus"
              class="p-button-rounded p-button-sm btn-nova-conta-wave"
              [pTooltip]="texts.nova_conta"
              tooltipPosition="left"
              (click)="novaConta()">
      </button>
      <button pButton type="button"
              icon="pi pi-times"
              class="p-button-rounded p-button-text p-button-sm btn-fechar-wave"
              (click)="showDialogContas = false">
      </button>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- Lista de cards -->
  <div class="contas-cards-container" *ngIf="contasDialog.length > 0">
    <div class="conta-card" *ngFor="let conta of contasDialog; trackBy: trackByContaId" (click)="irParaTransacoes(conta)">
      <!-- Linha 1: Nome e Saldo -->
      <div class="conta-card-header">
        <div class="conta-nome">
          <span class="conta-id">{{ conta.id }}</span> - {{ conta.tituloDaConta }}
        </div>
        <div class="conta-saldo"
             [class.saldo-positivo]="conta.saldo >= 0"
             [class.saldo-negativo]="conta.saldo < 0">
          {{ formatarValorMonetario(conta.saldo, conta) }}
        </div>
      </div>

      <!-- Linha 2: Receitas e Despesas -->
      <div class="conta-card-body">
        <div class="conta-info-row">
          <div class="conta-info-item">
            <span class="info-label">{{ texts.total_receitas }}:</span>
            <span class="info-value valor-receita">
              {{ formatarValorMonetario(conta.valorTotalDeEntradas, conta) }}
            </span>
          </div>
          <div class="conta-info-item">
            <span class="info-label">{{ texts.total_despesas }}:</span>
            <span class="info-value valor-despesa">
              {{ formatarValorMonetario(conta.valorTotalDeSaidas, conta) }}
            </span>
          </div>
        </div>
        <div class="conta-info-row">
          <div class="conta-info-item">
            <span class="info-label">{{ texts.tipo_conta }}:</span>
            <span class="info-value">{{ tipoContaLabel(conta) }}</span>
          </div>
        </div>
      </div>

      <!-- Linha 3: Acoes -->
      <div class="conta-card-actions" (click)="$event.stopPropagation()">
        <button pButton type="button"
                icon="pi pi-pencil"
                class="p-button-rounded p-button-text p-button-sm btn-editar"
                [pTooltip]="tooltips.editar"
                tooltipPosition="top"
                (click)="editarConta(conta)">
        </button>
        <button pButton type="button"
                icon="pi pi-trash"
                class="p-button-rounded p-button-text p-button-sm btn-excluir"
                [pTooltip]="tooltips.excluir"
                tooltipPosition="top"
                (click)="deletarConta(conta)">
        </button>
      </div>
    </div>
  </div>

  <!-- Empty state -->
  <div *ngIf="contasDialog.length === 0" class="empty-state-dialog">
    <i class="pi pi-inbox"></i>
    <p>{{ texts.minhas_contas }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button"
            [label]="texts.fechar"
            icon="pi pi-times"
            class="p-button-text"
            (click)="showDialogContas = false">
    </button>
  </ng-template>
</p-dialog>

<!-- Dialog de Nova Conta -->
<p-dialog [(visible)]="showDialogNovaConta"
          [modal]="true"
          [style]="{ width: '480px' }"
          [breakpoints]="{ '520px': '95vw' }"
          [draggable]="false"
          [resizable]="false"
          [showHeader]="false"
          [closable]="true"
          styleClass="dialog-nova-conta">

  <!-- Wave Header -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-plus-circle" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.nova_conta }}</h2>
      </div>
    </div>
    <div class="dialog-wave-header-actions">
      <button pButton type="button"
              icon="pi pi-times"
              class="p-button-rounded p-button-text p-button-sm btn-fechar-wave"
              (click)="fecharDialogNovaConta()">
      </button>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- Formulario -->
  <form [formGroup]="novaContaForm" class="nova-conta-form">
    <!-- Moeda -->
    <div class="form-field">
      <label class="form-label">{{ texts.moeda }} <span class="required">*</span></label>
      <p-dropdown [options]="moedaOptions"
                  formControlName="moeda"
                  optionLabel="label"
                  [placeholder]="texts.selecione"
                  [showClear]="true"
                  appendTo="body"
                  panelStyleClass="dropdown-panel-above-modal"
                  styleClass="w-full"
                  [class.ng-invalid]="novaContaForm.get('moeda')?.invalid && novaContaForm.get('moeda')?.touched"
                  [class.ng-dirty]="novaContaForm.get('moeda')?.touched">
        <ng-template pTemplate="selectedItem" let-moeda>
          <div class="dropdown-moeda-item" *ngIf="moeda">
            <img [src]="moeda.flagUrl" class="flag-icon-small" alt="" *ngIf="moeda.flagUrl" />
            <span>{{ moeda.label }}</span>
          </div>
        </ng-template>
        <ng-template pTemplate="item" let-moeda>
          <div class="dropdown-moeda-item">
            <img [src]="moeda.flagUrl" class="flag-icon-small" alt="" *ngIf="moeda.flagUrl" />
            <span>{{ moeda.label }}</span>
          </div>
        </ng-template>
      </p-dropdown>
    </div>

    <!-- Saldo Inicial -->
    <div class="form-field">
      <label class="form-label">{{ texts.saldo_inicial }}</label>
      <p-inputNumber formControlName="saldoInicial"
                     [locale]="novaContaLocale"
                     [minFractionDigits]="novaContaCasasDecimais"
                     [maxFractionDigits]="novaContaCasasDecimais"
                     [useGrouping]="true"
                     [prefix]="novaContaCurrencyPrefix"
                     styleClass="w-full">
      </p-inputNumber>
    </div>

    <!-- Titulo da Conta -->
    <div class="form-field">
      <label class="form-label">{{ texts.titulo_da_conta }} <span class="required">*</span></label>
      <input formControlName="tituloDaConta"
             type="text"
             pInputText
             class="w-full"
             [class.ng-invalid]="novaContaForm.get('tituloDaConta')?.invalid && novaContaForm.get('tituloDaConta')?.touched"
             [class.ng-dirty]="novaContaForm.get('tituloDaConta')?.touched" />
    </div>

    <!-- Numero da Conta -->
    <div class="form-field">
      <label class="form-label">{{ texts.numero_da_conta }}</label>
      <input formControlName="numeroConta"
             type="text"
             pInputText
             class="w-full" />
    </div>
  </form>

  <ng-template pTemplate="footer">
    <button pButton type="button"
            [label]="texts.cancelar"
            icon="pi pi-times"
            class="p-button-text"
            (click)="fecharDialogNovaConta()">
    </button>
    <button pButton type="button"
            [label]="texts.salvar"
            icon="pi pi-check"
            class="btn-salvar-conta"
            [loading]="salvandoConta"
            (click)="submitNovaConta()">
    </button>
  </ng-template>
</p-dialog>

<!-- Dialog de confirmacao de exclusao -->
<p-dialog [(visible)]="deleteDialogVisible"
          [modal]="true"
          [style]="{ width: '400px' }"
          [breakpoints]="{ '500px': '90vw' }"
          [draggable]="false"
          [resizable]="false"
          [showHeader]="false"
          [closable]="true"
          styleClass="dialog-confirmacao-exclusao">

  <!-- Wave Header -->
  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.confirmacao }}</h2>
      </div>
    </div>
    <div class="dialog-wave-header-actions">
      <button pButton type="button"
              icon="pi pi-times"
              class="p-button-rounded p-button-text p-button-sm btn-fechar-wave"
              (click)="cancelarExclusao()">
      </button>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="delete-confirm-content">
    <span>{{ texts.confirmar_exclusao }}</span>
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button"
            [label]="texts.cancelar"
            icon="pi pi-times"
            class="p-button-text"
            (click)="cancelarExclusao()">
    </button>
    <button pButton type="button"
            [label]="texts.confirmar"
            icon="pi pi-check"
            class="p-button-danger"
            (click)="confirmarExclusao()">
    </button>
  </ng-template>
</p-dialog>

<p-toast></p-toast>
